/**
 * Template (output) types. Today only Shopify Product Export ships; future
 * targets register here. Used to tag and group reusable mapping templates.
 */
export type TemplateType = {
  id: string;
  label: string;
  shopifyOnly: boolean;
};

export const TEMPLATE_TYPES: readonly TemplateType[] = [
  {
    id: "shopify-product-export",
    label: "Shopify Product Export",
    shopifyOnly: true,
  },
];

export const DEFAULT_TEMPLATE_TYPE = "shopify-product-export";

export function templateTypeLabel(id: string): string {
  return TEMPLATE_TYPES.find((t) => t.id === id)?.label ?? id;
}
